import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LocaleKey } from 'utils';
import {
  Image,
} from 'components';
import { WhiteContainer } from 'containers';
import { tutorials } from '../instruments';

import styles from '../styles.module.scss';

interface ITutorialContainer {
  langBanner: string;
}

export const TutorialContainer:FC<ITutorialContainer> = ({ langBanner }) => {
  const { t } = useTranslation('tools');
  const language = langBanner || localStorage.getItem('lng') || LocaleKey.en;

  const videoBaseUrl = 'https://storage.googleapis.com/eclipse-cdn/';
  const tutorialTypes = ['product', 'agent', 'guideline'] as const;
  const languageCodes = ['br', 'de', 'en', 'es', 'fr', 'hy', 'it', 'pt'] as const;

  const videoMap: Record<string, string> = tutorialTypes.reduce((acc, type) => {
    languageCodes.forEach((lang) => {
      const basePath = type === 'guideline' ? 'files' : 'videos';
      const fileExtension = type === 'guideline' ? 'pdf' : 'mp4';
      const key = `Tutorial-${type}-${lang}`;
      acc[key] = `${basePath}/${key}.${fileExtension}`;
    });
    return acc;
  }, {} as Record<string, string>);

  const handleVideoFileUrls = (videoFiles: string): string => {
    const videoKey = `${videoFiles}${langBanner || language}`;
    return videoMap[videoKey] ? `${videoBaseUrl}${videoMap[videoKey]}` : '';
  };

  return (
    <div className={styles.instruments_content}>
      {tutorials.map(({
        icon,
        title,
        video,
        videoFile,
      }) => {
        const fileUrl = handleVideoFileUrls(videoFile);
        return (
          <WhiteContainer
            className={styles.instruments_item}
          >
            <a
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
              href={video[langBanner]}
              target="_blank"
              rel="noreferrer"
            >
              <Image
                url={icon}
                className={styles.instruments_img}
              />
            </a>
            <div className={styles.instruments_title}>
              {t(title, { lng: language })}
              {' '}
            </div>
            <div className={styles.instruments_btn_container}>
              <a
                href={fileUrl}
                download
                target="_blank"
                rel="noreferrer"
                className={styles.instruments_btn}
              >
                {t('Instruments_saved_', { lng: language })}
              </a>
            </div>
          </WhiteContainer>
        );
      })}
    </div>
  );
};
